<template>
  <BaseTable
    :column-defs="columnDefs"
    :row-data="rowData"
    :default-col-def="defaultColDef"
    :row-height="56"
    :tooltip-show-delay="1000"
    :tooltip-hide-delay="60000"
    @grid-ready="$emit('on:grid-ready', $event)"
  />
</template>
<script setup>
import { dateComparator } from '@/composeables/ag_grid/comparators.js';
import { getProfileTooltipContent } from '@/api/apefluencer.js';
import AgGridTooltip from '@/components/ag_grid/AgGridTooltip.vue';

import FollowedProfileCell from './cells/FollowedProfileCell.vue';
import IndicatorProfileCell from './cells/IndicatorProfileCell.vue';
import FirstFollowedCell from './cells/FirstFollowedCell.vue';

const props = defineProps({
  rowData: Array
});

const defaultColDef = {
  flex: 1,
  sortable: true,
  resizable: true,
  filter: false,
  tooltipComponent: AgGridTooltip
};
const columnDefs = [
  {
    headerName: 'Date Followed',
    field: 'datetime_followed',
    cellRenderer: 'BaseCellDateTime',
    comparator: dateComparator,
    cellRendererParams: { justifyStart: true }
  },
  {
    headerName: 'Followed Profile',
    field: 'user_followed_metadata',
    cellStyle: { display: 'flex', 'align-items': 'center' },
    sortable: false,
    cellRenderer: FollowedProfileCell,
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.user_followed_metadata ? getProfileTooltipContent(params.data.user_followed_metadata) : '';
    }
  },
  {
    headerName: 'Account Created',
    field: 'user_followed_metadata.created_at',
    type: 'rightAligned',
    comparator: dateComparator,
    cellRenderer: 'BaseCellDateTime'
  },
  {
    headerName: '# of Followers',
    field: 'user_followed_metadata.followers_count',
    type: 'rightAligned',
    cellRenderer: 'BaseCellNumber',
    cellRendererParams: { decimals: 0 }
  },
  {
    headerName: 'Indicator Profile',
    field: 'indicator_metadata',
    type: 'rightAligned',
    cellStyle: { display: 'flex', 'align-items': 'center' },
    sortable: false,
    cellRenderer: IndicatorProfileCell,
    cellRendererParams: { position: 'right' },
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.indicator_metadata ? getProfileTooltipContent(params.data.indicator_metadata) : '';
    }
  },
  {
    headerName: 'First Followed',
    field: 'first_followed',
    headerClass: 'ag-right-aligned-header',
    cellStyle: { display: 'flex', 'align-items': 'center' },
    sortable: false,
    cellRendererParams: { position: 'right' },
    cellRenderer: FirstFollowedCell,
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.first_followed?.indicator_metadata
        ? getProfileTooltipContent(params.data.first_followed?.indicator_metadata)
        : '';
    }
  }
];
</script>
